/* eslint-disable */
import api from '@/services/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

// Registra o service worker.
const pushSubscriber = async () => {
  try {
    const permissao = await Notification.requestPermission();

    if (permissao === 'granted') {
      const registration = await navigator.serviceWorker.register('./service-worker.js');
      const vapidPublicKey = process.env.VUE_APP_VAPID_PUBLIC_KEY;

      const vapidConvertido = urlBase64ToUint8Array(vapidPublicKey);

      await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: vapidConvertido
      });

      await api.post('push-notifications/subscribe', JSON.stringify(subscription));
    }

    return;
  } catch (error) {
    console.error('Error:', error);
  }
};


export default pushSubscriber;
